// Keeps decoded images alive so an <img> switching to them renders immediately
const MAX_CACHED_IMAGES = 40;
const cache = new Map<string, HTMLImageElement>();

export const preloadImage = (url?: string) => {
  if (!url) {
    return;
  }
  const cached = cache.get(url);
  if (cached) {
    cache.delete(url);
    cache.set(url, cached);
    return;
  }
  const image = new Image();
  image.src = url;
  image.decode?.().catch(() => undefined);
  cache.set(url, image);
  if (cache.size > MAX_CACHED_IMAGES) {
    cache.delete(cache.keys().next().value as string);
  }
};
